import { createFileRoute } from "@tanstack/react-router";

import VisitorBlocks from "../pages/VisitorBlocks";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/visitor-blocks")({
  component: VisitorBlocksRoute,
});

function VisitorBlocksRoute() {
  return (
    <RequireAuth require="chatbotAccess">
      <VisitorBlocks />
    </RequireAuth>
  );
}
